export { default } from './LandingPageSEOHead';
export type { LandingPageSEOHeadProps } from './LandingPageSEOHead';
